(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["celique-product-main"] && !Shopify.designMode) return;
  try {
    
/* Celique product page — shared scripts (safe to load more than once) */
(function () {
  if (window.__celiqueLoaded) return;
  window.__celiqueLoaded = true;

  var define = function (name, cls) { if (!customElements.get(name)) customElements.define(name, cls); };
  var ready = function (fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true }); else fn(); };
  var pad = function (n) { return String(n).padStart(2, '0'); };

  /* ---------- Countdown ---------- */
  define('celique-countdown', class extends HTMLElement {
    connectedCallback() { ready(() => this.init()); }
    init() {
      var raw = (this.dataset.end || '').trim();
      var timer = this.querySelector('[data-timer]');
      var end = raw ? new Date(raw.replace(' ', 'T')).getTime() : NaN;
      if (isNaN(end)) { if (timer) timer.hidden = true; return; }
      this.els = { d: this.querySelector('[data-d]'), h: this.querySelector('[data-h]'), m: this.querySelector('[data-m]'), s: this.querySelector('[data-s]'), dBox: this.querySelector('[data-days]') };
      var tick = () => {
        var diff = end - Date.now();
        if (diff <= 0) {
          clearInterval(this.t);
          diff = 0;
          if (this.dataset.hide === 'true' && !window.Shopify?.designMode) {
            var bar = this.closest('.cq-countdown'); if (bar) bar.hidden = true;
          }
        }
        var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
        if (this.els.dBox) this.els.dBox.hidden = d === 0;
        if (this.els.d) this.els.d.textContent = pad(d);
        this.els.h.textContent = pad(h); this.els.m.textContent = pad(m); this.els.s.textContent = pad(s);
      };
      tick();
      this.t = setInterval(tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.t); }
  });

  /* ---------- Gallery ---------- */
  define('celique-gallery', class extends HTMLElement {
    connectedCallback() { ready(() => this.init()); }
    init() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.index = 0;
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
      var prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
      if (this.slides.length < 2) { prev?.remove(); next?.remove(); return; }
      prev?.addEventListener('click', () => this.go(this.index - 1));
      next?.addEventListener('click', () => this.go(this.index + 1));
      var x0 = null, main = this.querySelector('.cq-gallery__main');
      main?.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      main?.addEventListener('touchend', e => {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
      });
    }
    go(i) {
      var n = this.slides.length; if (!n) return;
      this.index = (i + n) % n;
      this.slides.forEach((s, k) => s.classList.toggle('is-active', k === this.index));
      this.thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === this.index); t.setAttribute('aria-current', k === this.index); });
      this.thumbs[this.index]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  });

  /* ---------- Buy box (tiers, subscribe toggle, ATC) ---------- */
  define('celique-buy-box', class extends HTMLElement {
    connectedCallback() { ready(() => this.init()); }
    init() {
      this.tiers = Array.from(this.querySelectorAll('input[data-tier]'));
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.idInput = this.form.querySelector('input[name="id"]');
      this.qtyInput = this.form.querySelector('input[name="quantity"]');
      this.planInput = this.form.querySelector('input[name="selling_plan"]');
      this.btn = this.querySelector('[data-atc]');
      this.subToggle = this.querySelector('[data-sub-toggle]');
      this.opts = Array.from(this.querySelectorAll('[data-purchase]'));
      if (this.subToggle) {
        this.purchase = this.subToggle.checked ? 'sub' : 'one';
      } else {
        this.purchase = (this.opts.find(o => o.getAttribute('aria-checked') === 'true') || {}).dataset?.purchase || 'one';
      }

      if (this.tiers.length && !this.tiers.some(t => t.checked)) this.tiers[0].checked = true;
      this.tiers.forEach(t => t.addEventListener('change', () => this.update()));
      this.opts.forEach(o => o.addEventListener('click', () => { this.purchase = o.dataset.purchase; this.update(); }));
      this.subToggle?.addEventListener('change', () => { this.purchase = this.subToggle.checked ? 'sub' : 'one'; this.update(); });
      this.update();

      var ship = this.querySelector('[data-ship-date]');
      if (ship) {
        var d = new Date(); d.setDate(d.getDate() + (parseInt(ship.dataset.days, 10) || 3));
        var day = d.getDate(), suf = (day % 100 >= 11 && day % 100 <= 13) ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
        ship.textContent = d.toLocaleDateString('en-US', { month: 'long' }) + ' ' + day + suf;
      }
    }
    update() {
      var sub = this.purchase === 'sub' && !!this.planInput;
      this.purchase = sub ? 'sub' : 'one';
      this.opts.forEach(o => o.setAttribute('aria-checked', o.dataset.purchase === this.purchase));
      if (this.subToggle) {
        this.subToggle.checked = sub;
        var subWrap = this.subToggle.closest('.cq-subscribe');
        if (subWrap) subWrap.classList.toggle('is-on', sub);
      }
      var selected = null;
      this.tiers.forEach(t => {
        var d = t.dataset, useSub = sub && d.subPrice;
        var card = t.closest('.cq-tier');
        if (t.checked) selected = t;
        if (!card) return;
        card.classList.toggle('is-selected', t.checked);
        var p = card.querySelector('.cq-tier__price'), c = card.querySelector('.cq-tier__compare'), s = card.querySelector('.cq-tier__save');
        if (p) p.textContent = useSub ? d.subPrice : d.price;
        if (c) c.textContent = useSub ? d.subCompare : d.compare;
        if (s) s.textContent = useSub ? d.subSave : d.save;
      });
      if (!selected) return;
      var sd = selected.dataset, useSub = sub && sd.subPrice;
      this.idInput.value = sd.variant;
      this.qtyInput.value = sd.qty;
      if (this.planInput) this.planInput.disabled = !useSub;
      if (this.btn) {
        var available = sd.available === 'true';
        this.btn.disabled = !available;
        this.btn.querySelector('[data-atc-label]').textContent = available ? this.btn.dataset.label : this.btn.dataset.soldout;
        this.btn.querySelector('[data-atc-price]').textContent = available ? (useSub ? sd.subPrice : sd.price) : '';
        this.btn.querySelector('[data-atc-sep]').hidden = !available;
        this.btn.querySelector('[data-atc-compare]').textContent = available ? (useSub ? sd.subCompare : sd.compare) : '';
      }
    }
  });

  /* ---------- Slider ---------- */
  define('celique-slider', class extends HTMLElement {
    connectedCallback() { ready(() => this.init()); }
    init() {
      this.track = this.querySelector('[data-track]');
      this.dotsWrap = this.querySelector('[data-dots]');
      this.nav = this.querySelector('.cq-slider__nav');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track) return;
      this.prev?.addEventListener('click', () => this.go(this.current() - 1));
      this.next?.addEventListener('click', () => this.go(this.current() + 1));
      this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.sync()); }, { passive: true });
      this.ro = new ResizeObserver(() => this.build());
      this.ro.observe(this.track);
    }
    disconnectedCallback() { this.ro?.disconnect(); }
    slides() { return Array.from(this.track.children); }
    step() { var s = this.slides(); return s.length > 1 ? s[1].offsetLeft - s[0].offsetLeft : this.track.clientWidth; }
    positions() {
      var s = this.slides(); if (!s.length) return 0;
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      var per = Math.max(1, Math.round((this.track.clientWidth + gap) / this.step()));
      return Math.max(1, s.length - per + 1);
    }
    current() { return Math.min(this.positions() - 1, Math.round(this.track.scrollLeft / this.step())); }
    build() {
      var n = this.positions();
      if (this.nav) this.nav.hidden = n < 2;
      if (!this.dotsWrap) return this.sync();
      this.dotsWrap.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'cq-slider__dot'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', this.go.bind(this, i));
        this.dotsWrap.appendChild(b);
      }
      this.sync();
    }
    go(i) {
      var n = this.positions(), idx = Math.max(0, Math.min(n - 1, i));
      this.track.scrollTo({ left: idx * this.step(), behavior: 'smooth' });
    }
    sync() {
      var i = this.current(), n = this.positions();
      var atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
      if (atEnd) i = n - 1;
      Array.from(this.dotsWrap?.children || []).forEach((d, k) => d.setAttribute('aria-current', k === i));
      if (this.prev) this.prev.disabled = i <= 0;
      if (this.next) this.next.disabled = i >= n - 1;
    }
  });

  window.addEventListener('submit', function (e) { var form = e.target; if (!form || !form.classList || !form.classList.contains('cq-buy__form')) return; if (form.querySelector('input[name="return_to"]')) return; var drawer = document.querySelector('cart-drawer'); if (!drawer || typeof drawer.renderContents !== 'function') return; e.preventDefault(); e.stopImmediatePropagation(); var btn = form.querySelector('[type="submit"]'); if (!btn || btn.getAttribute('aria-busy') === 'true') return; btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '0.7'; if (!document.getElementById('cq-load-css')) { var st = document.createElement('style'); st.id = 'cq-load-css'; st.textContent = 'cart-drawer.cq-loading .drawer__inner-empty{display:none!important}cart-drawer.cq-loading .drawer__inner{position:relative}cart-drawer.cq-loading .drawer__inner>*{opacity:.35;pointer-events:none}cart-drawer.cq-loading .drawer__inner::after{content:"";position:absolute;top:50%;left:50%;width:3.6rem;height:3.6rem;margin:-1.8rem 0 0 -1.8rem;border:.35rem solid rgba(0,0,0,.12);border-top-color:#1b4d3e;border-radius:50%;animation:cqspin .7s linear infinite;z-index:5}@keyframes cqspin{to{transform:rotate(360deg)}}'; document.head.appendChild(st); } drawer.classList.add('cq-loading'); try { drawer.open(btn); } catch (err) {} var fd = new FormData(form); fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', window.location.pathname); var url = (window.routes && window.routes.cart_add_url) || '/cart/add'; fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd }) .then(function (r) { return r.json(); }) .then(function (res) { if (res.status) { try { drawer.close(); } catch (err) {} alert(res.description || res.message || 'Error'); return; } drawer.classList.remove('is-empty'); drawer.renderContents(res); }) .catch(function () { form.submit(); }) .finally(function () { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; drawer.classList.remove('cq-loading'); }); }, true);
  /* ---------- Sticky bar ---------- */
  define('celique-sticky-bar', class extends HTMLElement {
    connectedCallback() { ready(() => this.init()); }
    init() {
      this.bar = this.querySelector('.cq-sticky');
      var link = this.querySelector('[data-sticky-link]');
      link?.addEventListener('click', e => {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var el = document.querySelector(href);
        if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
      var target = document.getElementById('cq-atc');
      if (this.dataset.always === 'true' || !target || !('IntersectionObserver' in window)) { this.show(true); return; }
      this.io = new IntersectionObserver(([entry]) => {
        this.show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
      this.io.observe(target);
    }
    show(v) {
      this.classList.toggle('is-visible', v);
      var visible = v && this.bar && getComputedStyle(this.bar).display !== 'none';
      document.body.style.paddingBottom = visible ? this.bar.offsetHeight + 'px' : '';
    }
    disconnectedCallback() { this.io?.disconnect(); document.body.style.paddingBottom = ''; }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
